module.exports = __webpack_public_path__ + "static/media/verified.a1714586.png";